import React, { useEffect, useState } from "react";

import axiosInstance, { weburl } from "../../../axiosInstance";
import LoadingScreen from "../../components/LoadingScreen";
import toast from "react-hot-toast";
import Select from "react-select";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { Helmet } from "react-helmet";
import getDecryptData from "../../../helper/getDecryptData";
import AccountSidebar from "../../components/AccountSidebar";
import { useNavigate } from "react-router-dom";

const AccountBuyPlanAds = () => {
  
    const navigate = useNavigate();
  
  const [data, setData] = useState([]);
  const [Cat, setcat] = useState([]);
  const [ZoneData, setZoneData] = useState([]);
    const [MetData, setMetaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Buyloading, setBuyLoading] = useState(false);
  const [Buydata, setBuyData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [FreePrice, setFreePrice] = useState(false);
  const [thumbFile, setThumbFile] = useState(null);

  const [formData, setFormData] = useState({
    status: "true",
    pImage: "",
  });

    const [preview, setPreview] = useState(null);
const [file, setFile] = useState(null);
  const [videoThumbnail, setVideoThumbnail] = useState(null);

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    // Check if the file is an image
    const isImage = file.type.startsWith("image/");
    if (isImage) {
      const img = new Image();
      img.onload = () => {
        // Check image dimensions (1000px x 1000px)
        if (img.width !== 1375 || img.height !== 196) {
          toast.error("Image dimensions must be 1375 x 196");
        } else {
          setPreview(URL.createObjectURL(file));
          setFile(file);
        }
      };
      img.src = URL.createObjectURL(file);
    } else if (file.type.startsWith("video/")) {
      // Check if it's a video
      const videoElement = document.createElement("video");
      videoElement.onloadedmetadata = () => {
        // Check video duration (not exceeding 9 seconds)
        if (videoElement.duration > 9) {
          setFreePrice(false);
          setPreview(URL.createObjectURL(file));
          setFile(file);
          toast.error("The video duration exceed 9 seconds, so it is chargeable ");
        } else {
          setFreePrice(true);
          setPreview(URL.createObjectURL(file));
          setFile(file);
        }
      };
      videoElement.src = URL.createObjectURL(file);
    } else {
      toast.error("Only image or video files are allowed");
    }
  }
};
 

  const handleselectChange = (selectedValues) => {
    const categoryIds = selectedValues.map((category) => category.value); // Extracting ObjectId values
    setSelectedOptions(selectedValues);
    setFormData((prevData) => ({
      ...prevData,
      Category: categoryIds, // Setting the array of ObjectId values
    }));
  };

    const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file is an image (thumbnail for the video)
      const isImage = file.type.startsWith("image/");
      if (isImage) {
   
        const img = new Image();
        img.onload = () => {
          // Check image dimensions (1375px x 196px)
          if (img.width !== 1375 || img.height !== 196) {
            toast.error("Thumbnail dimensions must be 1375 x 196");
          } else {
           setThumbFile(file);
            setVideoThumbnail(URL.createObjectURL(file)); // Set video thumbnail
          }
        };
        img.src = URL.createObjectURL(file);
      } else {
        toast.error("Only image files are allowed for the thumbnail");
      }
    }
  };


  const fetchCat = async () => {
    try {
      const response = await axiosInstance.get("/all-category");
      console.log(response.data.categories);
      setcat(response.data.categories);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchZoneData = async () => {
    setLoading(true);
    console.log("response.data start");
    try {
      const response = await axiosInstance.get("/get-all-zones-category");
      console.log("response.data.Zones,", response.data.Zones);
      setZoneData(response.data.Zones || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

    const fetchmetaData = async () => {
    setLoading(true);
    console.log("response.data start");
    try {
      const response = await axiosInstance.get("/home-data");
      console.log("response.data.homeData,", response.data.homeData);
      setMetaData(response.data.homeData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchCat();
    fetchmetaData();
    fetchZoneData();
  }, []);

  const [filteredCities, setFilteredCities] = useState([]);

  // ✨ NEW: default fields for hourly/day-wise selection
  const [inputs, setInputs] = useState({
    type: "",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    Gender: "1",
    DOB: "",
    address: "",
    coverage: [], // this must be an array!
    department: [], // this must be an array!
    images: [],
    gallery: [],
    adslink: "",
    // New fields
    billingType: "daily",        // "hourly" | "daily"
    Quantity: 1           // number of hours/days
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;

    // Handle multi-checkbox logic
    if (type === "checkbox") {
      if (name === "OfferEquipment") {
        newValue = checked
          ? [...(inputs.OfferEquipment || []), value]
          : (inputs.OfferEquipment || []).filter((item) => item !== value);
      } else if (name === "NatureOfBusiness") {
        newValue = checked
          ? [...(inputs.NatureOfBusiness || []), value]
          : (inputs.NatureOfBusiness || []).filter((item) => item !== value);
      } else {
        newValue = checked;
        console.log(type, name, newValue);
      }
    } else if (type === "file") {
      // Handle file input
      newValue = files[0];
    } else {
      // Handle normal text inputs (including radios)
      newValue = value;
    }

    // State / city linkage
    if (name === "state") {
      const selectedState = ZoneData.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        setInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, ZoneData);
    }

    if (name === "coverage") {
      const value = e.target.value;
      const selected = [...(Array.isArray(inputs.coverage) ? inputs.coverage : [])];
      if (!selected.includes(value) && value !== "null") {
        selected.push(value);
        setInputs((prev) => ({
          ...prev,
          coverage: selected,
        }));
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }

    // Keep Quantity numeric
    if (name === "Quantity") {
      const num = Number(newValue);
      setInputs((prevData) => ({
        ...prevData,
        [name]: isNaN(num) || num < 1 ? 1 : num,
      }));
      return;
    }

    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const removeCoverage = (cityToRemove) => {
    setInputs((prev) => ({
      ...prev,
      coverage: prev.coverage.filter((c) => c !== cityToRemove),
    }));
  };

  const buyNow = async () => {
    if(!file){
      toast.error('Please Choose Image first');
      return;
    }
// Check if thumbnail is required for video
  if (file.type.startsWith("video/") && !videoThumbnail) {
    toast.error("Please upload a thumbnail for the video");
    return;
  }

    try {
      const decryptdatajson = await getDecryptData();
      const uId = decryptdatajson?._id;
      let totalAmount = 0;
      if(inputs.billingType === '1' ){
       totalAmount = MetData.hrPrice * inputs.Quantity;
      }else if(inputs.billingType === '0' ){
       totalAmount = MetData.dayPrice * inputs.Quantity
      }

        const fields = [
             { name: "adslink", message: "Please enter ads link" },
            { name: "state", message: "Please choose state" },
            { name: "coverage", message: "Please choose coverage area" },
            { name: "billingType", message: "Please choose type" },
            { name: "Quantity", message: "Please enter quantity" },

          ];
      
          for (const field of fields) {
            if (!inputs[field.name]) {
              toast.error(field.message);
               return;
            }
          }

        // Prepare the request data
      const mydata = {
         ...formData,
        userId: uId,               // use the decrypted user ID
        totalAmount: FreePrice ? 0 : totalAmount,  // pass the totalAmount from function argument
        razorpay_order_id: "",
        razorpay_payment_id: "",
        razorpay_signature: "",
        adsinput: file,
        state: inputs.state,
        coverage: inputs.coverage,
        adslink:inputs.adslink,
        type: inputs.billingType,           // "hourly" | "daily"
        Quantity: inputs.Quantity,   // number
        thumbnail: thumbFile,
      };

      // setBuyLoading(true);

      console.log('mydata',mydata)
      const { data } = await toast.promise(
        axiosInstance.post(`/buy-ads-by-user`, mydata,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    ),
        {
          loading: "Creating Ads",
          success: "Create ads sucesssfully!",
          error: "Failed to create ads.",
        }
      );

      const { success ,buyAds } = data;
      if (success) {
    
        if(!FreePrice){
     const options = {
                    key: MetData.keyId,
                    amount: buyAds.totalAmount * 100,
                    currency: "INR",
                    name: "Ontech Digital",
                    description: "Ontech Digital Find Local Service Professionals Near You!",
                    image: MetData.meta_logo,
                    order_id: buyAds.razorpay_order_id,
                    callback_url: `${weburl}user-ads-payment-verification`,
                    // prefill: {
                    //   name: "test gupta",
                    //   email: "test@gmail.com",
                    //   contact: "1234567890",
                    // },
                    notes: {
                      address: "razorapy official",
                    },
                    theme: {
                      color: "#3399cc",
                    },
                  };
                  const razor = new window.Razorpay(options);
                  razor.open();
         
        }else{
          toast.success('Create ADS successfully!')
          navigate('/account/all-ads');

        }
                    console.log('buyAds',buyAds)
             

      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setBuyLoading(false);
    } finally {
      setBuyLoading(false);
    }
  };

  return (
    <>
       

       <Header title={'Buy Ads'} searchtab={false}/>

      <Helmet>
        <title> Account Profile | {window.location.hostname}</title>
      </Helmet>

    <div className="user-dasboard whitesmoke" >

        <div className="container pt-4">
          <div className="row pb-4">

            <AccountSidebar />

            <div className="col-lg-9 my-lg-0 my-1">
<div className="bg-white rounded p-4" id="main-content">

  <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4"> Buy Ads</h1>
            </div>
          </div>
        </div>

        {loading ? <LoadingScreen /> : (
          <div className="card bg-transparent border-0 mb-4 ">
            <div className="row">
              <div className="col-md-4">
                <h5 className="mb-3">Create Ad</h5>
                <label htmlFor="adsinput" className={`rounded ${!preview ? 'p-5' : 'p-2'} text-center `} style={{ border: '3px dashed grey' }}>
      {preview && (
  <div className="text-center my-3">
    {/* Preview for Image */}
    {file && file.type.startsWith("image/") && (
      <img
        src={preview}
        alt="Ad Preview"
        style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
      />
    )}

    {/* Preview for Video */}
    {file && file.type.startsWith("video/") && (
      <video
        controls
        src={preview}
        style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
        alt="Ad Preview"
      />
    )}

   
  </div>
)}


      {!preview && <>
      <div className="mb-3">
                    <i className="ri-upload-2-line text-secondary fs-1" />
                  </div>
                  <p className="text-muted">
                    Drag & drop your ad image or click to upload
                  </p>
      </>
      }
                  
                  <input type="file" className="form-control mb-3 d-none"  accept="image/*, video/*" name="adsinput" id="adsinput" onChange={handleImageChange} />
                  <div type="button" className="btn btn-primary">
                  {!preview ? 'Choose Image/video' : 'Change Image/video' }  
                  </div>
                </label>
<hr/>

      {/* If Video is selected, ask for Thumbnail */}
                        {file && file.type.startsWith("video/") && (
                          <>
                            <h5 className="mb-3">Add Video Thumbnail</h5>
                            <label
                              htmlFor="thumbnailinput"
                              className={`rounded ${!videoThumbnail ? "p-5" : "p-2"} text-center`}
                              style={{ border: "3px dashed grey" }}
                            >
                              {videoThumbnail && (
                                <div className="text-center my-3">
                                  <img
                                    src={videoThumbnail}
                                    alt="Video Thumbnail"
                                    style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
                                  />
                                </div>
                              )}
                              {!videoThumbnail && (
                                <>
                                  <div className="mb-3">
                                    <i className="ri-upload-2-line text-secondary fs-1" />
                                  </div>
                                  <p className="text-muted">
                                    Drag & drop your thumbnail image or click to upload
                                  </p>
                                </>
                              )}
                              <input
                                type="file"
                                className="form-control mb-3 d-none"
                                accept="image/*"
                                name="thumbnailinput"
                                id="thumbnailinput"
                                onChange={handleThumbnailChange}
                              />
                              <div type="button" className="btn btn-primary">
                                {!videoThumbnail ? "Choose Thumbnail" : "Change Thumbnail"}
                              </div>
                            </label>
                          </>
                        )}

<p className="text-center"> <span className="small" > Price Esitmation</span> 
{FreePrice ? <span className="h2 d-block text-success fw-bold"> Free </span>  :
<span className="h2 d-block text-success fw-bold"> 
  ₹{MetData.hrPrice !== 0 && (inputs.billingType === '1' && MetData.hrPrice * inputs.Quantity)} {MetData.dayPrice !== 0 && (inputs.billingType === '0' && MetData.dayPrice * inputs.Quantity)}
   </span> 
}
 </p>


              </div>

              <div className="col-md-8">
                {/* ADS Link */}
                <div className="mb-4">
                  <label className="form-label text-dark" htmlFor="adslink">
                    ADS Link <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group input-sm">
                    <input
                      type="text"
                      id="adslink"
                      className="form-control"
                      name="adslink"
                      value={inputs.adslink}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* ✨ NEW: Hourly / Day-wise selection */}
                <div className="mb-3">
                  <label className="form-label text-dark d-block">
                    Duration Type <span className="text-danger">(Required)</span>
                  </label>
                  <div className="d-flex gap-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="billingType"
                        id="billingTypeHourly"
                        value="0"
                        checked={inputs.billingType === "0"}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" htmlFor="billingTypeHourly">
                        Hourly
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="billingType"
                        id="billingTypeDaily"
                        value="1"
                        checked={inputs.billingType === "1"}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" htmlFor="billingTypeDaily">
                        Day-wise
                      </label>
                    </div>
                  </div>
                </div>

                {/* ✨ NEW: Quantity input (hours/days) */}
                <div className="mb-4">
                  <label className="form-label text-dark" htmlFor="Quantity">
                    {inputs.billingType === "0" ? "Number of Hours" : "Number of Days"}{" "}
                    <span className="text-danger">(Required)</span>
                  </label>
                  <input
                    type="number"
                    min={1}
                    className="form-control"
                    id="Quantity"
                    name="Quantity"
                    value={inputs.Quantity}
                    onChange={handleChange}
                  />
                  <small className="text-muted">
                    This will be used to calculate your ad plan price. <span className="text-danger"> ₹{MetData.hrPrice !== 0 && (inputs.billingType === '1' && MetData.hrPrice * inputs.Quantity)}
                    {MetData.dayPrice !== 0 && (inputs.billingType === '0' && MetData.dayPrice * inputs.Quantity)} </span>
                  </small>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-4">
                      <label htmlFor="title">Choose Category</label>
                      <Select
                        isMulti
                        value={selectedOptions}
                        name="Category"
                        onChange={handleselectChange}
                        placeholder={loading ? "Loading..." : "Select options"}
                        options={Cat.map((category) => ({
                          value: category._id,
                          label: category.title,
                        }))}
                      />
                    </div>
                  </div>

                  <div className="mb-4 col-12 col-md-12 ">
                    <label className="form-label text-dark" htmlFor="state">
                      State <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group input-sm">
                      <select
                        className="form-control"
                        id="state"
                        name="state"
                        value={inputs.state}
                        onChange={handleChange}
                      >
                        <option disabled>
                          {loading ? "Loading..." : "Select State"}
                        </option>
                        {ZoneData.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.name}
                          </option>
                        ))}{" "}
                        ;
                      </select>
                    </div>
                  </div>

                  {/* Multi Select for Coverage */}
                  <div className="mb-2 col-12">
                    <label className="form-label text-dark" htmlFor="coverage">
                      Coverage Areas <span className="text-muted">(Multi Select)</span>
                    </label>
                    <div className="input-group input-sm">
                      <select
                        className="form-control"
                        id="coverage"
                        name="coverage"
                        onChange={handleChange}
                        value={'null'}
                      >
                        <option value="null">Select Coverage Area</option>
                        {filteredCities.map((city, index) => (
                          <option key={index} value={city}>
                            {city} - (City)
                          </option>
                        ))}
                        {ZoneData.map((item) => (
                          <option key={item._id} value={item.name}>
                            {item.name} - (State)
                          </option>
                        ))}{" "}
                      </select>
                    </div>
                  </div>

                  <div className="mb-4">
                    {Array.isArray(inputs.coverage) && inputs.coverage.length > 0 ? (
                      inputs.coverage.map((city, index) => (
                        <span
                          key={index}
                          className="badge bg-primary me-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => removeCoverage(city)}
                          title="Click to remove"
                        >
                          {city} ×
                        </span>
                      ))
                    ) : (
                      <span className="text-muted">No coverage cities selected.</span>
                    )}
                  </div>

<div className="col-12">
 {!Buyloading ? (
                      <button
                        className="btn btn-primary btn-lg"
                        type="button"
                        onClick={()=>{
                          buyNow()
                        }}
                      >
                      {FreePrice ? 'Create Free ADS' : 'Pay Now'}  
                      </button>
                    ) : (
                      <button
                        class="btn btn-primary btn-sm"
                        type="button"
                        disabled
                      >
                        <span class="ms-1">Loading...</span>
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </button>
                    )}

</div>
                      

                </div>
              </div>
            </div>
          </div>
        )}

          
</div>


            </div>
            </div>
            </div>
            </div>

      
      <Footer/>

    </>
  );
};

export default AccountBuyPlanAds;
